import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {
    bindUser,
    getChatsUnreadNum,
    getMains,
    getUserInfo,
    login,
    logout,
    setRead,
    signOpeid,
    unReadNum
} from "@/api/api"
import {getToken, removeToken, setToken} from "@/config/cookies";
import {TagsViewModule} from "./tags-view";
import store from "@/store";
import {getUuid} from "@/config/local";

const baseUrl: string | undefined = process.env.VUE_APP_SOCKET_URL;

export interface IUserState {
    token: string;
    name: string;
    avatar: string;
    account: string;
    qq: string;
    email: any;
    phone: string;
    aid: string;
    roles: string[];
    role_ids: string[];
    menuList: string[];
    navigations: string[]
    buttonsAuth: string[]
    message: any
    socketTask: any
    socketFlag: boolean
    chatBossId: number
    chatsNums: any
    mainInfo: any
    notice: number
    receiveOrderTag: boolean,
    orderMessage:any
    otherPush:any
}

@Module({ dynamic: true, store, name: "user" })
class User extends VuexModule implements IUserState {
    public token = getToken() || "";
    public account = "";
    public name = "";
    public avatar = "";
    public qq = "";
    public email = "";
    public phone = "";
    public aid = "";
    public roles: string[] = [];
    public role_ids: string[] = [];
    public menuList: string[] = [];
    public navigations: string[] = [];
    public allRoutes: string[] = [];
    public buttonsAuth: string[] = [];
    public message: any = {};
    public socketTask: any = null;
    public socketFlag = false;
    public chatBossId = -1;
    public chatsNums = {
        total: 0
    };
    public mainInfo = {
        mp: {},
        app: {},
        total: {},
        mini:{}
    };
    public notice: any = 0;
    public receiveOrderTag = true;
    public orderMessage:any = null;
    public otherPush:any = null;

    @Mutation
    SET_ORDER_MESSAGE(payload:any){
        this.orderMessage = payload
    }

    @Mutation
    SET_OTHER_MESSAGE(payload:any){
        this.otherPush = {
            ...payload,
            myAid: this.aid
        }
    }

    @Mutation
    SET_NOTICE(payload?: number) {
        this.notice = payload;
    }

    @Mutation
    SET_REV_ORDER_TAG(payload: boolean) {
        this.receiveOrderTag = payload;
    }

    @Mutation
    SET_CHATSNUMS(payload: any) {
        this.chatsNums = payload;
    }

    @Mutation
    private SET_MESSAGE(message: any) {
        this.message = message;
    }

    @Mutation
    public SET_CHATBOSSID(payload: any) {
        this.chatBossId = payload;
    }

    @Mutation
    private SET_SOCKET_TASK(payload: any) {
        this.socketTask = payload;
    }

    @Mutation
    private SET_SOCKET_FLAG(payload: boolean) {
        this.socketFlag = payload;
    }

    @Mutation
    private SET_MENULIST(menuList: string[]) {
        this.menuList = menuList;
    }

    @Mutation
    SET_TOKEN(token: string) {
        this.token = token;
    }

    @Mutation
    private SET_NAME(name: string) {
        this.name = name;
    }

    @Mutation
    private SET_AVATAR(avatar: string) {
        this.avatar = avatar;
    }

    @Mutation
    private SET_QQ(qq: string) {
        this.qq = qq;
    }

    @Mutation
    private SET_EMAIL(email: string) {
        this.email = email;
    }

    @Mutation
    private SET_PHONE(phone: string) {
        this.phone = phone;
    }

    @Mutation
    private SET_ROLES(roles: string[]) {
        this.roles = roles;
    }

    @Mutation
    private SET_ACCOUNT(account: string) {
        this.account = account;
    }

    @Mutation
    private SET_AIDS(aid: string) {
        this.aid = aid;
    }

    @Mutation
    private SET_ROLEIDS(role_ids: string[]) {
        this.role_ids = role_ids;
    }

    @Mutation
    private SET_MAINS_INFO(payload: any) {
        this.mainInfo = payload || {};
        this.mainInfo.mp = payload.mp || {};
        this.mainInfo.app = payload.app || {};
        this.mainInfo.total = payload.total || {};
        this.mainInfo.mini = payload.mini || {}
        this.notice = payload.message_unread_total || 0;
    }

    @Mutation
    private SET_NAVIGATIONS(payload: any) {
        this.navigations = [];
        let rights: string[] = [];
        let routes: string[] = [];

        payload.forEach((element: any) => {
            if (element.a && element.a.length > 0) {
                rights = rights.concat(element.a);
            }

            if (element.u) {
                routes.push(element.u)
            }

            if (element.l && element.l.length > 0) {
                for (let item of element.l) {
                    if (item.l && item.l.length > 0) {
                        this.navigations.push(item.l);
                    }

                    if (item.a && item.a.length > 0) {
                        rights = rights.concat(item.a);
                    }

                    if (item.u) {
                        routes.push(item.u)
                    }


                    if (item.l && item.l.length > 0) {
                        for (let ele of item.l) {
                            if (ele.a && ele.a.length > 0) {
                                rights = rights.concat(ele.a);
                            }

                            if (ele.u) {
                                routes.push(ele.u)
                            }
                        }
                    }
                }
            }
        });

        let h = [...new Set(rights)];
        this.buttonsAuth = h;
        this.allRoutes = routes;
    }

    @Action
    public async Login(userInfo: { username: string; password: string }) {
        let { username, password } = userInfo;
        let account = username.trim();

        const { data, code }: any = await login({ account, password })

        if (code === 1000) {
            setToken(data.token);
            this.SET_TOKEN(data.token);
            this.InitSocket();
            this.GetChatsNum();
        } else {
            return data
        }
    }

    @Action
    public ResetToken() {
        removeToken();
        this.SET_TOKEN("");
        this.SET_ACCOUNT("");
        this.SET_ROLES([]);
        if (this.socketTask) {
            this.socketTask.close();
        }
    }

    /**
     * 一键登录
     */
    @Action
    public async OneClickLogin(openid: string) {
        const { code, data }: any = await signOpeid({ openid });

        if (code == 1000) {
            this.SET_TOKEN(data.token);
            setToken(data.token);
        }
    }

    @Action
    public async GetChatsNum() {
        const { code, data }: any = await getChatsUnreadNum();

        if (code == 1000) {
            this.SET_CHATSNUMS(data);
        } else {
            this.SET_REV_ORDER_TAG(false)
        }
    }

    @Action
    public async GetUserInfo() {
        if (this.token === "") {
            throw Error("GetUserInfo: token is undefined!");
        }

        try {
            const { data, code }: any = await getUserInfo({ menu: 1 });

            if (code == 1000) {
                const { aid, account, name, avatar, qq, email, phone, role_ids, roles, menu_auth_list } = data

                this.SET_ROLES(roles);
                this.SET_NAME(name);
                this.SET_AVATAR(avatar);
                this.SET_QQ(qq);
                this.SET_EMAIL(email);
                this.SET_PHONE(phone);
                this.SET_AIDS(aid);
                this.SET_ROLEIDS(role_ids);
                this.SET_ACCOUNT(account);
                this.SET_MENULIST(menu_auth_list);
                this.SET_NAVIGATIONS(menu_auth_list);
            } else {
                this.ResetToken();
                throw Error("Verification failed, please Login again.");
            }

        } catch (err) {
            console.log(err);
            this.ResetToken();
            throw Error("初始化用户信息错误！");
        }
    }

    @Action
    public async GetMainData() {
        const { code, data }: any = await getMains();

        if (code == 1000) {
            this.SET_MAINS_INFO(data)
        }
    }

    //未读消息数量
    @Action
    public async GetMsgNum(){
        const {code,data}:any = await unReadNum();
        if(code == 1000){
            this.SET_NOTICE(data.total)
        }
    }

    @Action
    public async setMsgRead(id:any){
        const {code,data,msg}:any = await setRead({id});
        if(code == 1000){
            this.GetMsgNum();
        }
        return {code,data,msg}
    }

    @Action
    public async LogOut() {
        if (this.token === "") {
            throw Error("LogOut: token is undefined!");
        }
        const { code }: any = await logout();

        if (code == 1000) {
            this.ResetToken();
            TagsViewModule.delAllViews();
        }
    }

    @Action
    public SendAua(val: any) {
        if (this.socketTask) {
            let params = {
                type: "aua",
                sign: val.sign,
                params: val.params
            }

            try {
                this.socketTask.send(JSON.stringify(params))
            } catch (err) {
                //console.log(err);
            }
        }
    }

    @Action
    public CheckSocket() {
        let timer01 = setInterval(() => {
            try {
                if (this.socketTask) {
                    this.SET_SOCKET_FLAG(false);
                    this.socketTask.send(JSON.stringify({ type: "ping" }))

                    let timer02 = setTimeout(() => {
                        if (this.socketFlag) {
                            console.log("pong接收成功");
                            clearTimeout(timer02);
                        } else {
                            console.log("pong接收失败!");
                            if (window.navigator.onLine == true) {
                                if (this.socketTask) {
                                    this.socketTask.close();
                                }
                                this.SET_SOCKET_TASK(null);
                                this.InitSocket()
                            } else {
                                if (this.socketTask) {
                                    this.socketTask.close();
                                }
                                this.SET_SOCKET_TASK(null);
                            }

                            clearTimeout(timer02);
                            clearInterval(timer01);
                        }
                    }, 5000);
                }
            } catch (err) {
                if (this.socketTask) {
                    this.socketTask.close();
                }
                this.SET_SOCKET_TASK(null);
            }

        }, 30000);

        window.onoffline = () => {
            clearInterval(timer01);
        }
    }

    @Action
    public async InitSocket() {
        if (!window.WebSocket) {
            console.error("此浏览器不支持websocket");
            return;
        }

        try {
            let socket = new WebSocket(baseUrl + '');

            this.SET_SOCKET_TASK(socket);

            this.socketTask.onopen = (event: any): void => {
                console.log(event, "socket打开成功！");
            };

            this.socketTask.onerror = (event: any): void => {
                //console.log(event, "socket错误！");
                if (window.navigator.onLine == true) {
                    this.SET_SOCKET_TASK(null);
                    //this.InitSocket();
                }
            };

            this.socketTask.onmessage = async (res: any) => {
                let data: any = JSON.parse(res.data);

                if (data.event === 'connect') {
                    this.socketTask.send(JSON.stringify({ type: 'init', uuid: "!" + getUuid() || "", }))

                } else if (data.event === 'init') {
                    let { client_id } = data.data;

                    if (UserModule.token) {
                        const res: any = await bindUser({ client_id });

                        if (res.code === 1000) {
                            window.ononline = () => {
                                this.SET_SOCKET_TASK(null);
                                this.InitSocket();
                            }
                            this.CheckSocket();
                        } else {
                            console.log(res.msg, "绑定失败");
                            if (window.navigator.onLine == true) {
                                this.SET_SOCKET_TASK(null);
                                this.InitSocket();
                            }
                        }
                    }
                } else if (data.event === 'member_message') {
                    this.SET_MESSAGE(data.data)
                    this.GetChatsNum();
                } else if (data.event === 'message') {
                    if (data.code == 1000) {
                        this.SET_MESSAGE(data.data)
                        // store.commit("SET_MESSAGE", data.data);
                        this.GetChatsNum();
                    }
                } else if (data.event === 'pong') {
                    this.SET_SOCKET_FLAG(true);
                } else if (data.event === 'push') {
                    if(data.data.type == 'order'){
                        this.GetMsgNum();
                        var route = data.data.order.type == 1 ? '/trade-list' : '/offline-order';
                        if(this.allRoutes.includes(route)){
                            this.SET_ORDER_MESSAGE(data.data);
                        }
                    }
                    else{
                        this.SET_OTHER_MESSAGE(data.data);
                    }
                }
            }
        } catch (err) {
            console.log(err, "socket出现异常");
            if (window.navigator.onLine == true) {
                this.SET_SOCKET_TASK(null);
                this.InitSocket();
            }
        }
    }
}

export const UserModule = getModule(User);
